import { Card, HeaderRow, Button, Form, Col, Layout } from "@emanprague/ppaskit";
import { Input } from "@frui.ts/bootstrap";
import DisabledLoginReason from "components/DisabledLoginReason";
import type SimplePortalSettings from "entities/simplePortalSettings";
import { observer } from "mobx-react-lite";
import React from "react";
import styles from "./style.module.scss";

interface DisabledLoginCardProps {
  disabledLoginSetting: SimplePortalSettings;
  translateGeneral: (key: string) => string;
  translate: (key: string) => string;
  onSubmit: () => void;
  onFillDefault?: () => void;
}

const DisabledLoginCard: React.FunctionComponent<DisabledLoginCardProps> = observer(
  ({ disabledLoginSetting, onSubmit, translate, translateGeneral, onFillDefault }) => {
    return (
      <Card>
        <Card.Body>
          <HeaderRow level={3} title={translate("disabled_login_reason.title")}>
            <Button variant="primary" onClick={onSubmit} className="ml-3">
              {translateGeneral("save_button")}
            </Button>
          </HeaderRow>
          <p>{translate("disabled_login_reason.description")}</p>
          <p>{translate("disabled_login_reason.content_help")}</p>
          <Form>
            <Form.Row>
              <Form.Group as={Col} xs={12}>
                <Form.Label className="admin-form-header">{translate("disabled_login_reason.preview")}</Form.Label>
                <div className={styles.previewContainer}>
                  <Layout fluid="md" className="layout-pre-auth">
                    <DisabledLoginReason content={disabledLoginSetting.value} />
                  </Layout>
                </div>
              </Form.Group>
            </Form.Row>
            <Form.Row>
              <Form.Group as={Col} xs={12}>
                <Form.Label className="admin-form-header">{translate("disabled_login_reason.content")}</Form.Label>
                <Input {...{ as: "textarea", rows: 8 }} target={disabledLoginSetting} property="value" />
              </Form.Group>
            </Form.Row>
            <Form.Row style={{ justifyContent: "flex-end" }}>
              <Button variant="link" onClick={onFillDefault} disabled={!onFillDefault}>
                {translate("disabled_login_reason.fill_default")}
              </Button>
            </Form.Row>
          </Form>
        </Card.Body>
      </Card>
    );
  }
);

export default DisabledLoginCard;
